<template>
	<b-card no-body class="m-0">
		<b-card-header header-tag="header" class="p-0" role="tab">
			<b-button block v-b-toggle.accordion-financing variant="light" class="py-4 accordion-button">FINÁNCIALO</b-button>
		</b-card-header>
		<b-collapse id="accordion-financing" accordion="services-accordion" role="tabpanel">
			<b-card-body>
				<h3 class="mt-5 text-center d-none d-lg-block">Simula tu Mejor Opción</h3>
		<h4 class="text-center d-lg-none mt-4 text-center">Simula tu Mejor Opción</h4>
		<b-row>
			<b-col md="6">
				<h4 class="ml-2 underline-macal">Principales Beneficios</h4>
				<ul class="pt-3 macal-ul">
					<li>Plazo desde 12 hasta 60 meses</li>
					<li>Primera cuota hasta 90 días</li>
					<li>Hasta 80% Financiamiento</li>
					<li>Deuda no aparece en el sistema financiero</li>
					<li>Pre-aprobación Online</li>
					<li>Créditos a tu medida</li>
					<li>Plan especial para Pymes</li>
				</ul>
			</b-col>
			<b-col md="6">
				<b-row>
					<b-col md="4">
						<b-form-group label="Monto">
							<b-form-input v-model.trim="$v.amount.$model" :state="$v.amount.$dirty ? !$v.amount.$error : null" placeholder="Monto" class="text-right" @keyup="milesFormater"></b-form-input>
						</b-form-group>
					</b-col>
					<b-col md="4">
						<b-form-group label="Pie">
							<b-form-select v-model.trim="$v.foot.$model" :options="foots" :state="$v.foot.$dirty ? !$v.foot.$error : null" >
							</b-form-select>
							<b-form-invalid-feedback id="input-1-live-feedback" v-if="!$v.foot.required">
								Debes ingresar Pie.
							</b-form-invalid-feedback>
							<b-form-invalid-feedback id="input-2-live-feedback">
								Monto del pie debe ser al menos 20% del valor total del vehículo, esto es ${{get20percent()|numberFormat}}
							</b-form-invalid-feedback>
						</b-form-group>
					</b-col>
					<b-col md="4">
						<b-form-group label="Cuotas">
							<b-form-select v-model="due" :options="duesOptions"></b-form-select>
						</b-form-group>
					</b-col>
				</b-row>
				<b-row>
					<b-col md="12">
						<b-button variant="macal" @click="calculate_finantial"  block >VER SIMULACIÓN</b-button>
					</b-col>
				</b-row>
				<b-row>
					<b-col>
						<b-table-simple v-if="this.loading" borderless class="bg-grey shadow-sm text-center mt-3">
							<b-tr>
								<b-td class="pt-0">
									<grid-loader class="mt-5" :color="color"></grid-loader>
								</b-td>
							</b-tr>
						</b-table-simple>
						<b-table-simple v-else borderless class="bg-grey shadow-sm text-center mt-3">
							<b-tr>
								<b-td>
									<h4>Resultado Simulación</h4>
								</b-td>
							</b-tr>
							<b-tr>
								<b-td class="py-0 text-macal px-5" >
									<div class="border-bottom-macal" >
										<div v-if="final_simulation.due.length == 0">
											<vue-content-loading :speed="2" :width="400" :height="40">
												<rect x="5" y="0" rx="0" ry="0" width="380" height="30" />
											</vue-content-loading>
										</div>
										<h5 v-else="">
											<b>{{final_simulation.due}} cuotas</b>
										</h5>
									</div>
								</b-td>
							</b-tr>
							<b-tr>
								<div v-if="final_simulation.amount.length == 0">
									<vue-content-loading :speed="2" :width="90" :height="30">
										<rect x="10" y="2" rx="10"  width="70" height="100" />
									</vue-content-loading>
								</div>
								<b-td v-else="" class="py-0 text-macal">
									<h1><b>$ {{final_simulation.amount | numberFormat}}*</b></h1>
								</b-td>
							</b-tr>
							<b-tr>
								<div v-if="final_simulation.cae.length == 0">
									<vue-content-loading :speed="2" :width="400" :height="10">
										<rect x="100" y="0" rx="0" ry="0" width="200" height="10" />
									</vue-content-loading>
								</div>
								<b-td v-else class="py-0 text-macal">
									CAE: {{final_simulation.cae | numberFormat}}%
								</b-td>
							</b-tr>
							<b-tr>
								<div v-if="final_simulation.total.length == 0">
									<vue-content-loading :speed="2" :width="400" :height="10">
										<rect x="140" y="0" rx="0" ry="0" width="120" height="10" />
									</vue-content-loading>
								</div>
								<b-td v-else="" class="pt-0">
									Valor Crédito: ${{final_simulation.total | numberFormat}}
								</b-td>
							</b-tr>
							<b-tr v-if="final_simulation.total">
								<b-td class="pt-0 text-center">
									<a href="javascript:;" @click="goFinancing()" size="lg" class="mt-3 pl-5 pr-5 btn btn-macal" variant="macal">¡SOLICITALO AQUI!</a>
								</b-td>
							</b-tr>
						</b-table-simple>	
					</b-col>
				</b-row>
			</b-col>
			<b-row v-if="simulation.legal">
				<b-col v-if="simulation.legal.length > 0" class="mt-3" cols="12">
					<small>{{simulation.legal[2]}}</small><br />
					<small>{{simulation.legal[1]}}</small>
				</b-col>
			</b-row>
		</b-row>
			</b-card-body>
		</b-collapse>
	</b-card>
</template>

<script>
	import VueContentLoading from 'vue-content-loading';
	import { required, minLength } from "vuelidate/lib/validators";
	import {  isFootValidTab } from "@/validators";

  export default {
	name: 'v-tab-financing',
	props: {
		price: {default: ""},
		simulation: {
			cae: {default: ""},
			total: {default: ""},
			amount: {default: ""},
			due: {default: ""},
			credit: {default: ""},
			legal: { type: Array }
		}
	},
	components:{
		VueContentLoading
	},
	data (){
		return{
			amount: "",
			due: 60,
			loading: false,
           foots:[
                {text: "1.000.000", value: "1000000"},
                {text: "2.000.000", value: "2000000"},
                {text: "3.000.000", value: "3000000"},
                {text: "4.000.000", value: "4000000"},
                {text: "5.000.000", value: "5000000"},
                {text: "6.000.000", value: "6000000"},
                {text: "7.000.000", value: "7000000"},
                {text: "8.000.000", value: "8000000"},
                {text: "9.000.000", value: "9000000"},
                {text: "10.000.000", value: "10000000"},
                {text: "12.000.000", value: "12000000"},
                {text: "14.000.000", value: "14000000"},
                {text: "16.000.000", value: "16000000"},
                {text: "18.000.000", value: "18000000"},
                {text: "20.000.000", value: "20000000"},
                {text: "25.000.000", value: "25000000"},
                {text: "30.000.000", value: "30000000"},
			],
			foots_mounts: [1000000,2000000,3000000,4000000,5000000,6000000,7000000,8000000,9000000,10000000,12000000,14000000,16000000,18000000,20000000,25000000,30000000],
			color: "#E4610C",
			duesOptions: [12,24,36,48,60],
			foot: "",
			final_simulation: {
				cae: "",
				total: "",
				amount: "",
				due: "",
				credit: "",
				foot: ""
			}
		}
	},
	validations: {
		foot: { required, isFootValidTab: isFootValidTab },
		amount: { required ,minLength: minLength(6) },
	},
	mounted(){},
	methods:{
		goFinancing(){
			this.$router.push({name: 'vehicles-financing', params: {simulation: this.final_simulation } });
		},
		get20percent(){
			return parseInt(this.amount.replace(/[^\dKk]/g, '')) * 0.2
		},
		set_foot(){
			let percentage = parseInt(this.amount.split(".").join("")) * 0.3
			let result = this.foots_mounts.reduce(function(prev, curr) {
				return (Math.abs(curr - percentage) < Math.abs(prev - percentage) ? curr : prev);
			});
			this.foot = result
			this.final_simulation.foot = this.foot
		},
		milesFormater(){
			this.amount = this.amount.toString().replace(/\./g, "").replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.")
		},
		calculate_finantial(){
			this.$v.$touch()
			if(!this.$v.$invalid){
				this.loading = true
				this.axios.post("financings/simulation", {amount: this.amount, due: this.due, foot: this.foot}).then(result => {
					this.final_simulation = result.data
					this.final_simulation.credit = this.amount
					this.final_simulation.foot = this.foot
					this.loading = false
				}).catch(() => {
					this.loading = false
				})
			}
		}
	},
	watch: {
		"simulation.credit": {
			handler: function() {
				this.final_simulation = this.simulation;
				this.amount = this.simulation.credit;
				this.set_foot();
			}
		}
	}
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>